import React, { useState, useEffect } from "react";
import { Button, Image } from "antd"; // , Typography
// import { BellOutlined } from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import useMediaQuery from "use-media-antd-query"; // , { MediaQueryKey }

import ModalLogin from "../modalLogin/index.js";
// import { color } from "../../Theme/Color";
import "../../assets/css/header.css";
// import "../../assets/css/publish.css";

// const { Text } = Typography;

const navigation = [
  {
    url: "home",
    tittle: "Produk",
  },
  {
    url: "contact",
    tittle: "Kontak",
  },
];

// const profile = [
//   {
//     id: "daftar",
//     tittle: "Daftar",
//   },
//   {
//     id: "masuk",
//     tittle: "Masuk",
//   },
// ];

function Header({ content, isLogin, logo, params }) {
  const [modal, setModal] = useState(false);
  // const [isAdmin, setisAdmin] = useState(true);
  const [isAdmin, setisAdmin] = useState(false);
  const colSize = useMediaQuery();
  const [mobileView, setMobileView] = useState(colSize);

  useEffect(() => {
    setMobileView(colSize);
  }, [colSize]);

  const buttonClickedHandler = () => {
    setModal(!modal);
  };

  const buttonLogout = () => {
    localStorage.clear();
    history.push("/");
    window.location.reload();
  };

  const closeModal = () => {
    setModal(false);
  };

  let history = useHistory();
  let prev = history.location.prevPath;
  return (
    <header style={{ marginBottom: "70px" }}>
      <nav className="header-container">
        <div>
          <Image
            width={mobileView === "xs" ? 60 : 76}
            src={logo}
            preview={false}
            style={{ cursor: "pointer" }}
            onClick={() => history.push("/")}
          />
        </div>
        {content && (
          <>
            <div style={{ textAlign: "center" }}>
              {navigation.map((v, i) => (
                <Link
                  to={{ pathname: v.url, prevPath: history.location.pathname }}
                  style={{ marginRight: mobileView === "xs" ? 10 : 40 }}
                  className={
                    params !== v.url
                      ? prev && prev.substring(1) === v.url
                        ? "hover-underline-animation inactive"
                        : "hover-underline-animation"
                      : "active"
                  }
                  key={i}
                >
                  <p>{v.tittle}</p>
                </Link>
              ))}
              {isLogin && (
                <Link
                  to={{
                    pathname: "my-application",
                    prevPath: history.location.pathname,
                  }}
                  style={{ marginRight: mobileView === "xs" ? 10 : 40 }}
                  className={
                    params !== "my-application"
                      ? prev && prev.substring(1) === "my-application"
                        ? "hover-underline-animation inactive"
                        : "hover-underline-animation"
                      : "active"
                  }
                >
                  <p>{isAdmin ? "Setting" : "Daftar Paket"}</p>
                </Link>
              )}
            </div>

            <div>
              {isLogin ? (
                <Button className="button-apply" onClick={buttonLogout}>
                  <h5 style={{ color: "#fff", margin: "auto" }}>Keluar</h5>
                </Button>
              ) : (
                <Button className="button-apply" onClick={buttonClickedHandler}>
                  <h5 style={{ color: "#fff", margin: "auto" }}>Masuk</h5>
                </Button>
                // profile.map((v, i) => (
                //   <Text
                //     style={{ marginRight: 40 }}
                //     className="hover-underline-animation"
                //     key={i}
                //     onClick={buttonClickedHandler}
                //   >
                //     <p>{v.tittle}</p>
                //   </Text>
                // ))
              )}
            </div>
          </>
        )}
      </nav>

      {/* modal login */}

      <div>
        <ModalLogin
          isOpen={modal}
          buttonClicked={buttonClickedHandler}
          onClose={closeModal}
        />
      </div>
    </header>
  );
}

export default Header;
